"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentStoreAccessControl__factory = void 0;
var _ethers = require("ethers");
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

class DocumentStoreAccessControl__factory extends _ethers.ContractFactory {
  constructor(signer) {
    super(_abi, _bytecode, signer);
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address) {
    return super.attach(address);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }
}
exports.DocumentStoreAccessControl__factory = DocumentStoreAccessControl__factory;
const _abi = [{
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "uint8",
    name: "version",
    type: "uint8"
  }],
  name: "Initialized",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "previousAdminRole",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "newAdminRole",
    type: "bytes32"
  }],
  name: "RoleAdminChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleRevoked",
  type: "event"
}, {
  inputs: [],
  name: "DEFAULT_ADMIN_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "ISSUER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "REVOKER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }],
  name: "getRoleAdmin",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "grantRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "hasRole",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "renounceRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "revokeRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}];
const _bytecode = "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";